<template>
    <t-space direction="vertical" style="width: 100%;" size="small">
        <t-row style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card
                    title="库存盘点说明" 
                    brodered 
                    style="width: 85vw;" 
                    :hoverShadow="true">
                    <t-row>
                        <t-steps separator="arrow" :current="stepCurrent" readonly>
                            <t-step-item title="选择盘点仓库" content="选择需要进行盘点任务的仓库,选择后进行下一步">
                                <template  v-if="stepCurrent===0" #extra>
                                    <t-button theme="primary" variant="text" @click="goNextStep" :disabled="beSelectWarehouseInfo === undefined">下一步</t-button>
                                </template>
                            </t-step-item>
                            <t-step-item title="建立盘点任务" content="建立盘点任务，核实所选仓库信息是否正确，确认点击创立任务后，进行下一步" >
                                <template  v-if="stepCurrent===1" #extra>
                                    <t-button size="small" variant="text" @click="goBackStep" :disabled="finshedTask"> 上一步 </t-button>
                                    <t-button theme="primary" variant="text" @click="goNextStep" :disabled="!finshedTask">下一步</t-button>
                                </template>
                            </t-step-item>
                            <t-step-item title="进行盘点任务" content="对所选择的仓库进行盘点任务" >
                                <template  v-if="stepCurrent===2" #extra>
                                    <!-- <t-button size="small" variant="text" @click="goBackStep"> 上一步 </t-button> -->
                                    <t-button theme="primary" variant="text" @click="goNextStep">下一步</t-button>
                                </template>
                            </t-step-item>
                            <t-step-item title="确认盘点结果" content="对盘点结果进行确认，结束盘点任务">
                                <template  v-if="stepCurrent===3" #extra>
                                    <t-button size="small" variant="text" @click="goBackStep"> 上一步 </t-button>
                                </template>
                            </t-step-item>
                        </t-steps>
                    </t-row>
                    <t-row>
                        <t-link theme="primary" hover="color" @click="goToWarehouseCheck"> 返回任务列表 </t-link>
                    </t-row>
                </t-card>
            </t-col>
            <t-col></t-col>
        </t-row>
        <!--选择所选仓库-->
        <t-row v-if="stepCurrent===0" style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card
                    title="库存盘点" 
                    brodered 
                    style="width: 85vw; height: 60vh;" 
                    :hoverShadow="true">
                    <t-table 
                            row-key="index"
                            :columns="columns"
                            :data="warehouseListData"
                            :selected-row-keys="selectedRowKeys"
                            :select-on-row-click="selectOnRowClick"
                            @select-change="rehandleSelectChange">
                    </t-table>
                </t-card>
            </t-col>
            <t-col></t-col>
        </t-row>
        <!--建立盘点任务-->
        <t-row v-if="stepCurrent===1" style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card
                    title="库存盘点创建" 
                    brodered 
                    style="width: 85vw; height: 60vh;" 
                    :hoverShadow="true">
                    <t-space direction="vertical" size="small">
                        <t-row>
                            <t-input label="任务单名称：" v-model="taskName" :status="taskNameInputStatus"></t-input>
                        </t-row>
                        <t-row>
                            <t-input label="创建人：" v-model="creator" :status="creatorInputStatus"></t-input>
                        </t-row>
                        <t-row>
                            <t-input label="补充描述：" v-model="description"></t-input>
                        </t-row>
                        <t-row>
                            <t-descriptions title="核实所选仓库信息" bordered :column="3">
                                <t-descriptions-item label="仓库编号">{{beSelectWarehouseInfo.warehouseId}}</t-descriptions-item>
                                <t-descriptions-item label="仓库类型r">{{beSelectWarehouseInfo.warehouseType}}</t-descriptions-item>
                                <t-descriptions-item label="仓库名称">{{beSelectWarehouseInfo.warehouseName}}</t-descriptions-item>
                                <t-descriptions-item label="负责人">{{beSelectWarehouseInfo.warehouseManager}}</t-descriptions-item>
                                <t-descriptions-item label="仓库地址">{{beSelectWarehouseInfo.warehouseAddress}}</t-descriptions-item>
                            </t-descriptions>
                        </t-row>
                        <t-row>
                            <t-button variant="text" theme="primary" :loading="createTaskLoading" @click="createTask">确认无误，创建盘点任务单</t-button>
                        </t-row>
                    </t-space>
                </t-card>
            </t-col>
            <t-col></t-col>
        </t-row>
        <!--进行盘点任务-->
        <t-row v-if="stepCurrent===2" style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card
                    title="库存盘点" 
                    brodered 
                    style="width: 85vw; height: 60vh;" 
                    :hoverShadow="true">
                    <t-row>
                        <t-table
                        :data="taskItemData"
                        :resizable="true"
                        :height="'40vh'"
                        cell-empty-content="-"
                        @row-edit="onRowEdit"
                        :pagination="pageConfig"
                        :columns="taskItemTableColumns">
                        </t-table>
                    </t-row>
                </t-card>
            </t-col>
            <t-col></t-col>
        </t-row>

        <!--生成盘点盈亏单-->
        <t-row v-if="stepCurrent===3" style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card
                    title="库存盘点完成确认" 
                    brodered 
                    
                    style="width: 85vw; height: 60vh;" 
                    :hoverShadow="true">
                    <t-space direction="vertical">
                        <t-row>
                            <t-typography-text>请在确认盘点任务已经完全结束，并进行确认</t-typography-text>
                        </t-row>

                        <t-row>
                            <t-descriptions  bordered :column="3">
                                <t-descriptions-item label="该次任务存在待盘数量"> {{noCheckAmount}}</t-descriptions-item>
                            </t-descriptions>
                        </t-row>
                        <t-row>
                            <t-link theme="primary" hover="color" @click="finish">确认已完成</t-link>
                        </t-row>
                    </t-space>
                </t-card>
            </t-col>
            <t-col></t-col>
        </t-row>

    </t-space>
</template>

<script lang="jsx" setup>
import { onMounted, ref } from 'vue';
import request from '@/request/request';
import { NotifyPlugin,Input } from 'tdesign-vue-next';
import router from '@/router/main';
import { ErrorCircleFilledIcon, CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue-next';

const taskNameInputStatus = ref("")
const creatorInputStatus = ref("")
const stepCurrent = ref(0)
const taskName = ref("")
const creator = ref("")
const description = ref("")
const noCheckAmount = ref(0)
const columns = [
    {
        colKey: 'row-select',
        type: 'single',
        checkProps: { allowUncheck: true },
    },
    {title: '仓库编号',colKey: "warehouseId"},
    {title: '仓库类型',colKey: "warehouseType"},
    {title: '仓库名称',colKey: "warehouseName",},
    {title: "简称",colKey: "warehouseBriefName",},
    {title: '拼音码',colKey: "warehousePinYinCode"},
    {title: '仓库地址',colKey: "warehouseAddress"},
    {title: '负责人',colKey: "warehouseManager"},
    {title: '备注',colKey: "warehouseRemark"},
];

// const format = (val) => {
//     const reg = /(\d)(?=(?:\d{3})+$)/g;
//     const str = val.replace(reg, '$1,');
//     return str;
// };
// const editableRowKeys = ref([])

const pageConfig = ref({
    pageSize: 8, 
    defaultCurrent: 1, 
    defaultPageSize: 8,
    total: 100,
    // totalContent: false,
    showPageSize: false,
    onCurrentChange: (number,pageInfo)=>{
        console.log("current change",number,pageInfo);
        // requestInquiryBillOfDocumentList(number,pageInfo.pageSize,null)
        if(sessionStorage.getItem("warehouse_check_task_id")){
            request.RequestWarehouseChekTaskItem(number,8,sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
            if(res.data.success) {
                taskItemData.value = res.data.data
                for(let i = 0; i < taskItemData.value.length; i++) {
                    taskItemData.value[i].index = i
                }
            }else{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '任务列表请求失败',
                    duration: 2000
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败' + err,
                duration: 2000
            })
        })
        }
    }
})
const finish = ()=>{
    request.FinshedCheckTask(sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                title: "成功",
                content: '任务完成成功',
                duration: 2000
            })
            router.push('/home/warehouse_check')
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务完成失败',
                duration: 2000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '任务完成失败' + err,
            duration: 2000
        })
    })
}
const taskItemTableColumns = [
    { 
        title: '任务状态', 
        colKey: 'warehouseStatus',
        cell: (h, { row }) => {
            const statusNameListMap = {
                0: { label: '盘平', theme: 'success', icon: <CheckCircleFilledIcon /> },
                1: { label: '盘亏', theme: 'danger', icon: <CloseCircleFilledIcon /> },
                2: { label: '盘盈', theme: 'danger', icon: <CloseCircleFilledIcon /> },
                3: { label: '待盘', theme: 'warning', icon: <ErrorCircleFilledIcon /> },
            }
            let index = -1
            if(row.warehouseStatus === "盘平") index = 0
            else if(row.warehouseStatus === "盘亏") index = 1
            else if(row.warehouseStatus === "盘盈") index = 2
            else if(row.warehouseStatus === "待盘") index = 3
            return (
                <t-tag  theme={statusNameListMap[index].theme} variant="light-outline">
                    {statusNameListMap[index].icon}
                    {statusNameListMap[index].label}
                </t-tag>
            )
        }
    },
    {
        title: "盘点数量差量",
        colKey: "discrepancyQuantity",
        width: 150,
        edit:{
                component: Input,
                showEditIcon: true
            }
    },
    { title: '商品名称', colKey: 'goodsName' },
    {title: '入库时间', colKey: 'createDateTime'},
    { title: '商品编号', colKey: 'goodsId' },
    { title: '数量', colKey: 'amount' },
    { title: '单价(元)', colKey: 'price' },
    { title: '总计价值(元)', colKey: 'totalValue' },
    { title: '发票名称', colKey: 'nameOfInvoice' },
    { title: '简称', colKey: 'briefName' },
    { title: '存储位置', colKey: 'storageLocation' },
    { title: '拼音码', colKey: 'pinyinCode' },
    { title: '产地', colKey: 'placeOfProduction' },
    { title: '商品税率', colKey: 'commodityTaxRate'},
    { title: '重量', colKey: 'weight' },
    { title: '商品标签', colKey: 'goodsTags' },
    { title: '税码', colKey: 'taxCode' },
    { title: '长度', colKey: 'length' },
    { title: '宽度', colKey: 'width' },
    { title: '高度', colKey: 'height' },
    { title: '条形码策略', colKey: 'barcodeStrategy' },
    { title: '质保期', colKey: 'qualityGuaranteePeriod' },
    { title: '品牌', colKey: 'brand' },
    { title: '规格', colKey: 'specifications' },
    { title: '型号', colKey: 'model' },
    { title: '参考成本', colKey: 'referenceCost' },
    { title: '采购周期', colKey: 'purchasingCycle' },
    { title: '备注', colKey: 'remarks' },
    { title: '一级分类', colKey: 'firstLevelClassification' },
    { title: '二级分类', colKey: 'secondLevelClassification' },
    { title: '三级分类', colKey: 'thirdLevelClassification'},
    { 
        title: '操作',
        colKey: "action",
        fixed: 'right',
        width: 150,
        cell: (h, { row }) => {
                return (
                    <t-space class="table-operations" space="small">
                            <t-link theme="primary" style="color: green" hover="color" data-id={row.index} onClick={InventoryBalance}>
                                盘平 
                            </t-link>
                            <t-link theme="primary" style="color: orange" hover="color" data-id={row.index} onClick={InventoryGain}>
                                盘盈
                            </t-link>
                            <t-link theme="primary" style="color: red" hover="color" data-id={row.index} onClick={InventoryLoss}>
                                盘亏 
                            </t-link>
                    </t-space>
                );
        }
    }
]
const InventoryGain = (e)=>{
    const  id  = e.currentTarget.dataset.id
    if( taskItemData.value[id].discrepancyQuantity === "") {
        NotifyPlugin.error({
                    theme: 'error',
                    title: "盘盈失败",
                    content: "请填写盘点数量差量",
                    duration: 3000
                })
        return
    }
    if(sessionStorage.getItem("warehouse_check_task_id")) {
        request.RequestWarehouseCheckTaskStatusChange(
            sessionStorage.getItem("warehouse_check_task_id"),
            taskItemData.value[id].goodsId,
            "盘盈",
            taskItemData.value[id].discrepancyQuantity,
            (res)=>{
                if(res.data.success) {
                    taskItemData.value[id].warehouseStatus = "盘盈"
                    NotifyPlugin.success({
                        theme: 'success',
                        title: "盘盈成功",
                        content: "状态变更成功",
                        duration: 3000
                    })
                }else {
                    NotifyPlugin.error({
                        theme: 'error',
                        title: "盘盈失败",
                        content: "状态变更失败",
                        duration: 3000
                    })
                }
            },
            (err)=>{
                NotifyPlugin.error({
                    theme: 'error',
                    content: "状态变更失败"+err.message,
                    duration: 3000
                })
        })
    }
}
const InventoryLoss = (e)=>{
    const  id  = e.currentTarget.dataset.id
    if( taskItemData.value[id].discrepancyQuantity === "") {
        NotifyPlugin.error({
                    theme: 'error',
                    title: "盘亏失败",
                    content: "请填写盘点数量差量",
                    duration: 3000
                })
        return
    }
    if(sessionStorage.getItem("warehouse_check_task_id")) {
        request.RequestWarehouseCheckTaskStatusChange(
            sessionStorage.getItem("warehouse_check_task_id"),
            taskItemData.value[id].goodsId,
            "盘亏",
            taskItemData.value[id].discrepancyQuantity,
            (res)=>{
                if(res.data.success) {
                    taskItemData.value[id].warehouseStatus = "盘亏"
                    NotifyPlugin.success({
                        theme: 'success',
                        title: "盘亏成功",
                        content: "状态变更成功",
                        duration: 3000
                    })
                }else {
                    NotifyPlugin.error({
                        theme: 'error',
                        title: "盘亏失败",
                        content: "状态变更失败",
                        duration: 3000
                    })
                }
            },
            (err)=>{
                NotifyPlugin.error({
                    theme: 'error',
                    content: "状态变更失败"+err.message,
                    duration: 3000
                })
        })
    }
}
const InventoryBalance = (e)=>{
    const  id  = e.currentTarget.dataset.id
    if(sessionStorage.getItem("warehouse_check_task_id")) {
        request.RequestWarehouseCheckTaskStatusChange(
            sessionStorage.getItem("warehouse_check_task_id"),
            taskItemData.value[id].goodsId,
            "盘平",
            0,
            (res)=>{
                if(res.data.success) {
                    taskItemData.value[id].warehouseStatus = "盘平"
                    taskItemData.value[id].discrepancyQuantity = 0
                    NotifyPlugin.success({
                        theme: 'success',
                        title: "盘平成功",
                        content: "状态变更成功",
                        duration: 3000
                    })
                }else {
                    NotifyPlugin.error({
                        theme: 'error',
                        title: "盘平失败",
                        content: "状态变更失败",
                        duration: 3000
                    })
                }
            },
            (err)=>{
                NotifyPlugin.error({
                    theme: 'error',
                    content: "状态变更失败"+err.message,
                    duration: 3000
                })
        })
    }
}

const onRowEdit = (e)=>{
    taskItemData.value[e.rowIndex].discrepancyQuantity = e.value
}

// const updateEditState = (id) => {
//     const index = editableRowKeys.value.findIndex((t) => t === parseInt(id));
//     editableRowKeys.value.splice(index, 1);
// }

const selectedRowKeys = ref([]);
const selectOnRowClick = ref(true);
const beSelectWarehouseInfo = ref(undefined)
const warehouseListData = ref([
    // {
    //     index: 0,
    //     warehouseId: "1",
    //     warehouseType: "1",
    //     warehouseName: "1",
    //     warehouseBriefName: "1",
    //     warehousePinYinCode: "1",
    //     warehouseAddress: "1",
    //     warehouseManager: "1",
    //     warehouseRemark: "1"
    // }
])

const createTaskLoading = ref(false);
const finshedTask = ref(false);
const taskItemData = ref()

const goToWarehouseCheck = ()=>{
    sessionStorage.setItem("warehouse_task_step",0)
    router.push('/home/warehouse_check')
}

//选择要盘点的仓库
const rehandleSelectChange = (value) => {
    selectedRowKeys.value = value;
    beSelectWarehouseInfo.value = warehouseListData.value[value]
    sessionStorage.setItem("beSelectWarehouseInfo",JSON.stringify(beSelectWarehouseInfo.value))
    // console.log(value + "@", selectedRowData);
    // console.log(value + "!", beSelectWarehouseInfo.value);
}
//创建盘点任务
const createTask = () => {
    createTaskLoading.value = true
    let date = new Date()
    if(taskName.value==="") {
        taskNameInputStatus.value = "error"
        createTaskLoading.value = false
        return
    } 
    if(creator.value==="") {
        creatorInputStatus.value = "error"
        createTaskLoading.value = false
        return
    }
    let task_id = "PD" + date.getFullYear()  + (date.getMonth() + 1) + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds()
    request.CreateWarehouseCheckTask({
        id: task_id,
        name: taskName.value,
        creator: creator.value,
        description: description.value,
        warehouse_id: beSelectWarehouseInfo.value.warehouseId,
        warehouse_name: beSelectWarehouseInfo.value.warehouseName
    },(res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                theme: '数据获取成功',
                content: '创建盘点任务成功',
                duration: 3000
            })
            sessionStorage.setItem("warehouse_check_task_id",task_id)
            finshedTask.value = true
        }else {
            NotifyPlugin.error({
                theme: '数据获取失败',
                content: '创建盘点任务失败',
                duration: 3000
            })
        }
        createTaskLoading.value = false
    },(err)=>{
        createTaskLoading.value = false
        NotifyPlugin.error({
            theme: '数据获取失败',
            content: '创建盘点任务失败' + err,
            duration: 3000
        })
    })
}
//
const goBackStep = ()=>{
    stepCurrent.value--
    sessionStorage.setItem("warehouse_task_step",stepCurrent.value)
    if(stepCurrent.value === 2) {
        request.RequestWarehouseChekTaskItem(0,8,sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
            if(res.data.success) {
                taskItemData.value = res.data.data
                for(let i = 0; i < taskItemData.value.length; i++) {
                    taskItemData.value[i].index = i
                }
            }else{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '任务列表请求失败',
                    duration: 2000
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败' + err,
                duration: 2000
            })
        })
    }
}

const goNextStep = ()=>{
    stepCurrent.value++
    sessionStorage.setItem("warehouse_task_step",stepCurrent.value)
    if(stepCurrent.value === 2) {
        request.RequestWarehouseChekTaskItem(0,8,sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
            if(res.data.success) {
                taskItemData.value = res.data.data
                for(let i = 0; i < taskItemData.value.length; i++) {
                    taskItemData.value[i].index = i
                }
            }else{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '任务列表请求失败',
                    duration: 2000
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败' + err,
                duration: 2000
            })
        })
    }else if(stepCurrent.value === 3) {
        request.GetWarehouseTaskItemNoCheck(sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
            if(res.data.success) {
                noCheckAmount.value = res.data.data.length
            }else{
                NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败',
                duration: 3000
            })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败' + err,
                duration: 3000
            })
        })
    }
}

onMounted(()=>{
    if( sessionStorage.getItem("warehouse_task_step") === undefined || sessionStorage.getItem("warehouse_task_step") === null ){
        sessionStorage.setItem("warehouse_task_step",0)
    }else{
        stepCurrent.value = parseInt(sessionStorage.getItem("warehouse_task_step")) 
    }
    if(sessionStorage.getItem("beSelectWarehouseInfo") !== undefined && sessionStorage.getItem("beSelectWarehouseInfo") !== null){
        beSelectWarehouseInfo.value = JSON.parse(sessionStorage.getItem("beSelectWarehouseInfo"))
    }
    request.RequestQueryWarehouseInfo(0,8,{},
    (res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                let info = {}
                info.index = i
                info.warehouseId = data[i].warehouseId
                info.warehouseType = data[i].warehouseType
                info.warehouseName = data[i].warehouseName
                info.warehouseBriefName = data[i].warehouseBriefName
                info.warehousePinYinCode = data[i].warehousePinYinCode
                info.warehouseManager = data[i].warehouseManager
                info.warehouseRemark = data[i].warehouseRemark
                info.warehouseAddress = data[i].warehouseAddress
                warehouseListData.value.push(info)
            }
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '仓库信息请求失败',
                duration: 2000
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '仓库信息请求失败' + err,
            duration: 2000
        })
    })
    //请求获得盘点单表项目
    if(sessionStorage.getItem("warehouse_check_task_id")) {
        request.RequestWarehouseChekTaskItem(0,8,sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
            if(res.data.success) {
                taskItemData.value = res.data.data
                for(let i = 0; i < taskItemData.value.length; i++) {
                    taskItemData.value[i].index = i
                }
            }else{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '任务列表请求失败',
                    duration: 2000
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败' + err,
                duration: 2000
            })
        })
        request.GetWarehouseCheckTaskItemsAmount(sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
            if(res.data.success) {
                pageConfig.value.total = res.data.data
            }else{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '任务列表请求数量失败',
                    duration: 2000
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求数量失败' + err,
                duration: 2000
            })
        })
        request.GetWarehouseTaskItemNoCheck(sessionStorage.getItem("warehouse_check_task_id"),(res)=>{
            if(res.data.success) {
                noCheckAmount.value = res.data.data.length
            }else{
                NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败',
                duration: 3000
            })
            }
        },(err)=>{
            NotifyPlugin.error({
                title: "请求失败",
                content: '任务列表请求失败' + err,
                duration: 3000
            })
        })
    }
    

})

</script>

<style scoped>

</style>